import script from "./ResourceCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceCreateView.vue?vue&type=script&setup=true&lang=js"

import "./ResourceCreateView.vue?vue&type=style&index=0&id=763fce5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763fce5c"]])

export default __exports__